import {ExecutionResult} from 'graphql'
import * as React from 'react'
import {SEND_RESET_PASSWORD_EMAIL_MUTATION} from '../../mutations/SEND_RESET_PASSWORD_EMAIL_MUTATION'
import {
  SendResetPasswordEmailMutation,
  SendResetPasswordEmailMutationVariables,
} from '../../schema/schemaTypes'
import {apolloClient} from '../../utils/apolloClient'
import {ForgotPasswordView, IFormValues} from './ForgotPasswordView'

// tslint:disable-next-line:no-empty-interface
interface IInputProps {
}

interface IChildState {
  is: null | 'loading' | 'error' | 'success'
}

export class ForgotPasswordContainer extends React.PureComponent<IInputProps, IChildState> {
  public state: IChildState = {is: null}

  public render() {
    return <ForgotPasswordView
      is={this.state.is}
      doResetPassword={this.doResetPassword}
    />
  }

  private doResetPassword = async ({email}: IFormValues) => {
    this.setState({is: 'loading'})
    try {
      const {data}: ExecutionResult<SendResetPasswordEmailMutation> =
        await apolloClient.mutate<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>({
          mutation: SEND_RESET_PASSWORD_EMAIL_MUTATION, variables: {email},
        }) as any
      this.setState({is: null})
      if (!data || !data.sendResetPasswordEmail) {
        return this.setState({is: 'error'})
      }
      location.assign('/email-sent')
    } catch (err) {
      this.setState({is: 'error'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/organisms/ForgotPasswordForm/ForgotPasswordContainer.tsx